import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Alert,
  CircularProgress,
  Button,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';
import { API_CONFIG } from '../config/config';

const VerifyEmailChange = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmailChange = async () => {
      try {
        const response = await fetch(`${API_CONFIG.BASE_URL}/auth/verify-email-change/${token}`, {
          method: 'GET',
        });

        const data = await response.json();
        
        if (data.success) {
          setSuccess(true);
          setMessage(data.message);
        } else {
          setError(data.message);
        }
      } catch (err) {
        setError('Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      verifyEmailChange();
    } else {
      setError('Ungültiger Verifizierungslink.');
      setLoading(false);
    }
  }, [token]);

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        flexDirection: 'column',
        gap: 2
      }}>
        <CircularProgress size={60} />
        <Typography variant="h6">E-Mail-Adresse wird verifiziert...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      px: 2
    }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 500, width: '100%' }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          {success ? (
            <CheckCircleIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
          ) : (
            <ErrorIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
          )}
          <Typography variant="h4" gutterBottom>
            {success ? 'E-Mail-Adresse bestätigt' : 'Verifizierung fehlgeschlagen'}
          </Typography>
        </Box>

        {success ? (
          <Alert severity="success" sx={{ mb: 3 }}>
            {message}
          </Alert>
        ) : (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <Box sx={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            onClick={() => navigate('/dashboard')}
            sx={{ mr: 2 }}
          >
            Zum Dashboard
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate('/profile')}
          >
            Zu den Profileinstellungen
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default VerifyEmailChange;

